import { IProfile } from '../../api/public/profile-api';
import { LanguageLandingPageType } from '../../api/public/static-pages-api';
import { ISlLoginResponse } from '../../login/private/global.interface';
import { IFlashMessageTypes } from '../../shared/public/SlFlashMessage/SlFlashMessage';

export enum StatusType {
	pending = 'pending',
	success = 'success',
	error = 'error',
}

export enum CareerSections {
	CareerHeader = 'CareerHeader',
	Benefits = 'Benefits',
	QuoteSection = 'QuoteSection',
	Gallery = 'Gallery',
	Footer = 'Footer',
}

export interface IBenefitsData {
	id: number;
	title: string;
	description: string;
	emoji: string;
}

export interface IBenefitsProps {
	title: string;
	benefits: IBenefitsData[];
}

export interface ICareerFooterProps {
	title: string;
	actionText: string;
	actionUrl?: string;
}

export interface ICareerHeaderProps {
	title: string;
	description: string;
	actionText: string;
	actionUrl: string;
}

export enum ImageSize {
	medium = 'medium',
	large = 'large',
}

export interface ImageProps {
	id?: number;
	size: ImageSize;
	imageUrl: string;
}

export interface IGalleryProps {
	title: string;
	subtitle: string;
	images?: ImageProps[];
}

export interface IQuoteSectionProps {
	text: string;
	author: string;
}

export interface ICareerSectionData {
	sectionId: number;
	sectionName: string;
	data:
	| ICareerHeaderProps
	| IBenefitsProps
	| IQuoteSectionProps
	| IGalleryProps
	| ICareerFooterProps;
}

export interface ICareerPage {
	careerPage: ICareerSectionData[];
}

export const NON_CODING_REDIRECT_LINK = '/users/signup';

export interface ILPTracking {
	prefix: string;
	entityId: number;
}

export interface IFlashMessage {
	type: IFlashMessageTypes;
	message: string;
}

export enum FlashMessages {
	smtWentWrong = 'Oops! Something went wrong, please try again later',
	success = 'You have successfully updated your notification preferences!',
}

export const EmailNotificationTitle = 'Notification settings';

export type UnsubscribedMessageType = Record<string, boolean>;

export interface IEmailUsInputs {
	name: string;
	email: string;
	message: string;
	category: string;
}

export interface ISlPrivacyRequestInputs {
	person?: 'me' | 'agent';
	firstName: string;
	lastName: string;
	address1: string;
	address2: string;
	city: string;
	state: string;
	zipCode: string;
	email: string;
	phone: string;
}

export interface IProfileData extends IProfile {
	isOwnProfile: boolean;
}

export enum ICertificateTrackEventNames {
	landingPageCertificateImpression = 'landing_page_certificate_impression', // user sees the certificate from other user
	landingPageCertificateClick = 'landing_page_certificate_click',
	userCertificateImpression = 'user_certificate_impression', // user sees their own certificate
	userCertificateClick = 'user_certificate_click',
}

export enum ICertificateTrackClickTypes {
	startLearning = 'START LEARNING',
	browseOtherCourses = 'BROWSE OTHER COURSES',
	interestedCourses = 'COURSES YOU MAY BE INTERESTED',
	copy = 'COPY',
	downloadPdf = 'DOWNLOAD PDF',
	downloadImg = 'DOWNLOAD IMAGE',
	share = 'SHARE',
}

export interface IModule {
	title: string;
	iconUrl: string;
	id: number;
}

export interface ICourse {
	id: number;
	imgUrl: string;
	title: string;
	description: string;
}

export enum LanguageLandingPage {
	Header = 'header',
	WhyLearn = 'why_learn',
	WhatCanIAchieve = 'what_can_i_achieve',
	AllCourses = 'all_courses',
	RunCodeYourself = 'run_code_yourself',
	Testimonials = 'testimonials',
	Blog = 'blog',
	PreFooter = 'footer',
}

export enum LanguageLandingSectionType {
	Main_Header_Page = 'MAIN HEADER PAGE',
	Custom = 'CUSTOM',
}

export enum RequestType {
	Parallel = 'parallel',
	Cancelable = 'cancelable',
}

export interface IStaticPagesActionData {
	url?: string;
	authData?: ISlLoginResponse;
	certificateId?: string;
	userId?: number;
	landingPageAlias?: string;
	trackingData?: ITrackingData;
	languageAlias?: string;
	landingPageData?: LanguageLandingPageType[];
	sectionType?: LanguageLandingSectionType;
	sectionTitle?: string;
	clickType?: string;
	waitlistId?: string;
	email?: string;
	trackParams?: ITrackParams;
}

// new tracking
export interface ITrackingData {
	event_name: ICertificateTrackEventNames;
	course_alias: string;
	click_type?: ICertificateTrackClickTypes;
	user_id?: string;
	fngrprnt_id?: string;
}

export interface ITrackParams {
	sectionTitle?: string;
	buttonId?: string;
	buttonLabel?: string;
	clickType?: 'CTA' | 'APP_LINK' | 'EXPAND';
	email?: string;
}
